module.exports = __webpack_public_path__ + "img/sleep-blue.5238a573.svg";